import { useSelector } from 'react-redux';

import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { useGetProfileParticipantTasksQuery } from 'store/api/pkd/endpoints/participantTask';
import { filterParticipantTask } from 'utils/participantTask';
import { getAttribute } from 'utils/person';

const useMyTasks = ({ status, limit }) => {
  const { personAccountProfileId, person, isPersonLoading } =
    useGetPersonAndAttributes();

  const isPkd1MigratedUser = Boolean(
    getAttribute(person, 'is_r0_5_migrated_user')
  );

  const {
    participantTaskIds,
    numberOfTasks,
    isParticipantTaskLoading,
    refetch: refetchProfileParticipantTasks,
  } = useGetProfileParticipantTasksQuery(
    {
      personAccountProfileId,
      params : status ? { status } : {},
    },
    {
      skip             : !personAccountProfileId,
      selectFromResult : ({ data, isLoading, isFetching }) => {
        return {
          participantTaskIds : data
            ?.filter?.(
              (task, index, tasks) =>
                !isPkd1MigratedUser || filterParticipantTask(tasks, task)
            )
            ?.map?.(({ id }) => id)
            ?.slice?.(...(limit ? [0, limit] : [0])),
          numberOfTasks            : data?.length,
          isParticipantTaskLoading : isLoading || isFetching,
        };
      },
    }
  );

  const isSettingUpTasks = useSelector(
    ({ application }) => application.isSettingUpParticipantTasks
  );

  const didTasksSetupFail = useSelector(
    ({ application }) => application.participantTasksSetupFailed
  );

  const isLoading = isPersonLoading || isParticipantTaskLoading;

  return {
    participantTaskIds,
    numberOfTasks,
    isLoading,
    isSettingUpTasks,
    didTasksSetupFail,
    refetchProfileParticipantTasks,
  };
};

export default useMyTasks;
